import React, { useEffect, useState } from 'react';

import cn from 'classnames';

import { TCommentType } from '@entities/comment/model/types';
import { CustomModal } from '@shared/ui';
import { CommentsContent } from '@widgets/Comments/ui/Content';

import cls from './Comments.module.css';

interface ICommentsProps {
    className?: string;
    isOpen?: boolean;
    onClose?: () => void;
    positionGuid?: string;
    positionName?: string;
    commentType?: TCommentType;
    withChecklist?: boolean;
}

export const Comments = ({
    className,
    isOpen,
    onClose,
    commentType,
    positionGuid = '',
    positionName = '',
    withChecklist = false,
}: ICommentsProps) => {
    const [isChecklistOpen, setIsChecklistOpen] = useState(false);

    useEffect(() => {
        console.log('commentType', commentType);
    }, [commentType]);

    return (
        <CustomModal
            isOpen={isOpen}
            onHideModal={onClose}
            contentClasses={cn(
                cls.CommentsModalContent,
                isChecklistOpen && cls.CommentsModalContentShifted,
                isChecklistOpen && cls.resetBorderRadius
            )}
            classes={cls.CommentsModalOverlay}
            needClose={false}
            data-modal-type="comments"
        >
            <CustomModal.Body classes={cls.CommentsModalBody}>
                <CommentsContent
                    className={className}
                    positionGuid={positionGuid}
                    positionName={positionName}
                    commentType={commentType}
                    withChecklist={withChecklist}
                    onChecklistOpenChange={setIsChecklistOpen}
                />
            </CustomModal.Body>
        </CustomModal>
    );
};
